import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FeatureTourProps } from './FeatureTour.types';
import { FeatureDiscoveryWithProviders } from './FeatureDiscoveryWithProviders';
import { getStore } from 'utils/reduxStore';
import { FeatureDiscoveryStore } from '@sdb/planning-ui';

const FeatureTour = ({
  tourId,
  tourVersion,
  desktopSteps,
  mobileSteps,
  triggerComponent
}: FeatureTourProps) => {
  const storeState = getStore().getState();
  const userId = storeState?.userDetails?.accountId;
  const tenantId = storeState?.tenantDetails?.tenantId;

  if (!userId || !tenantId) return null;

  const environmentProps = {
    userId: String(userId),
    tenantId: String(tenantId)
  };

  const { t } = useTranslation('common', { keyPrefix: 'featureTour' });
  const [tick, setTick] = useState(0);
  const [featureDiscoverStore] = useState(
    () => new FeatureDiscoveryStore(tourId)
  );

  const handleStartFeatureDiscovery = () => {
    requestAnimationFrame(() => {
      featureDiscoverStore.restart();
      setTick((x) => x + 1);
    });
  };

  return (
    <>
      <FeatureDiscoveryWithProviders
        {...environmentProps}
        key={`${tourId}-${featureDiscoverStore.open}-${tick}`}
        tourId={tourId}
        tourVersion={tourVersion}
        externalFeatureDiscoveryStore={featureDiscoverStore}
        previous={t('previous')}
        next={t('next')}
        done={t('done')}
        of={t('of')}
        desktopSteps={desktopSteps}
        mobileSteps={mobileSteps}
      />

      {triggerComponent(handleStartFeatureDiscovery)}
    </>
  );
};

export default FeatureTour;
